exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5fcc84a9] .el-switch__label--right{margin-left:6px}.el-icon--right[data-v-5fcc84a9]{margin-left:0}[data-v-5fcc84a9] .el-card__body{padding:0 20px}.cell .el-tag[data-v-5fcc84a9]{background-color:#fff}[data-v-5fcc84a9] .el-table .cell{overflow:none;text-overflow:clip}\n", ""]);

// exports
